import { type MissingScanFilter } from '@/models/domain/missing-scan'

/**
 * Path and URL state for Missing Scans (web-portal#71). The filter and the
 * view ride along as params, so Back and Forward move between a barcode's
 * timeline and the counts it was opened from.
 */
export const MISSING_SCANS_PATH = '/admin/inventory/missing-scans'

export type MissingScanView = 'counts' | 'timeline'

export function missingScanParams(
  filter: MissingScanFilter,
  view: MissingScanView
): Record<string, string> {
  const params: Record<string, string> = { from: filter.from, to: filter.to }
  if (filter.location) params.location = filter.location
  if (filter.barcode) params.barcode = filter.barcode
  if (view === 'timeline') params.view = view
  return params
}

/** The page, opened on a filter and view. */
export function missingScansPath(filter: MissingScanFilter, view: MissingScanView): string {
  return `${MISSING_SCANS_PATH}?${new URLSearchParams(missingScanParams(filter, view)).toString()}`
}
